<template>
  <v-menu transition="slide-y-transition" bottom open-on-hover offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text class="white--text" dark v-on="on" @click="goToMain(category.name, category)">
        {{category.title}}
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(thing, i) in category.subCat"
        :key="i"
        @click="goToSub(thing.name, thing.articleList, thing.title)"
      >
        <v-list-item-title>{{thing.title}}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["category"],
  methods: {
    goToMain: function(page, list) {
      this.$router.push({ name: page, params: { subcategories: list } });
    },
    goToSub: function(page, list, title) {
      this.$router.push({
        name: page,
        params: { articleList: list, pageTitle: title }
      });
    }
  }
};
</script>